export default "__VITE_ASSET__DQIvIE17__"